import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { ApiSessionKeyGuard } from './api-session-key-guard.service';
import { SessionKeyHttpInterceptor } from './session-key-http-interceptor';

@NgModule({
  providers: [
    ApiSessionKeyGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SessionKeyHttpInterceptor,
      multi: true,
    }
  ]
})
export class SessionKeeperModule {
}
